// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var ArrowRight = function ArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.46 10.682a.94.94 0 0 0 0-1.36L11.587 2.76a.937.937 0 0 0-1.293 1.355l5.18 4.95H2.188a.935.935 0 0 0-.938.937c0 .52.418.938.938.938h13.285l-5.184 4.945a.938.938 0 0 0 1.293 1.356l6.875-6.563z"
  }));
};
